<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <EventForm @submit-requested="submitRequested"></EventForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import EventForm from './EventForm.vue'

  export default {
  components: { EventForm },
  methods: {
    ...mapActions('events', ['postEvent']),
    submitRequested (input) {
      this.postEvent(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 